import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { pickListEngagmentDataPopup, resetPickEngagmentListData } from "../store/actions";
import { useEffect, useState } from "react";
import { DropDown } from "../../../components";


const EngagmentSelectPicker = (props: any) => {
    const dispatch = useDispatch();

    const pickList = useSelector((state: any) => state.selectEngagmentPickCM);
    
    const [data, setData] = useState([])
    const [isChild, setIsChild] = useState<boolean>(false);

    useEffect(() => {
        // Fetch Information pickList
        try {
            if (props.isChild === null || props.isChild === undefined) {
                dispatch(
                    pickListEngagmentDataPopup({
                        token: props.token,
                        param: {
                            dspId: props.dspId,
                            parentPickListSelectedValue: '',
                            controlId: props?.items?.controlId,
                            caseSummaryType: props?.caseSummaryType,
                        },
                        url: props.items.apiPicklistEndpoint.endpointUrl.replace("/api", ""),
                    })
                );
            } else {
                const childData = props.isChild.find((element: any) => parseInt(element) === props.items.controlId);

                if (childData !== undefined) {
                    setIsChild(true);
                    // Don't fetch data initially for child picklists - wait for parent selection
                } else {
                    dispatch(
                        pickListEngagmentDataPopup({
                            token: props.token,
                            param: {
                                dspId: props.dspId,
                                parentPickListSelectedValue: '',
                                controlId: props.items.controlId,
                            },
                            url: props.items.apiPicklistEndpoint.endpointUrl.replace("/api", ""),
                        })
                    );
                }
            }
        } catch (e: any) {
            toast.error(e.message);
        }
    }, []);

    useEffect(() => {
        // Fetch Information pickList for child when parent value changes
        try {
            if (isChild && props?.childPropName !== undefined) {
                const parentValue = props?.formData[props?.childPropName];
                
                // Only fetch if parent has a value, otherwise clear the data
                if (parentValue && parentValue !== "" && parentValue !== "0") {
                    dispatch(
                        pickListEngagmentDataPopup({
                            token: props.token,
                            param: {
                                dspId: props.dspId,
                                parentPickListSelectedValue: parentValue,
                                controlId: props.items.controlId,
                            },
                            url: props.items.apiPicklistEndpoint.endpointUrl.replace("/api", ""),
                        })
                    );
                } else {
                    // Clear data when parent is not selected
                    setData([]);
                }
            }
        } catch (e: any) {
            toast.error(e.message);
        }
    }, [props?.formData[props?.childPropName], isChild]);

    useEffect(() => {
        if (pickList.isSuccess && pickList.data !== null && props.items.controlId === pickList.data.controlId) {
            setData(pickList.data.values);
            dispatch(resetPickEngagmentListData())
        } else if (pickList.isError) {
            dispatch(resetPickEngagmentListData())
        }
    }, [pickList])



    const parseDataForDropDown = (data: any) => {
        if (data === null || data === undefined) {
            return []
        }

        return data.map((option: any) => { return { "id": option.valueToStore, "title": option.textToDisplay, "value": option.valueToStore } })
    }

    // Check if this is a child picklist and if parent has no value
    const isDisabled = isChild && (!props?.formData?.[props?.childPropName] || props?.formData?.[props?.childPropName] === "" || props?.formData?.[props?.childPropName] === "0");

    return (
        <div key={props.items.controlId}>
            <DropDown
                label={props.items.label}
                labelExternal={true}
                key={"toolbar"}
                name={props.name}
                disabled={isDisabled}
                data={parseDataForDropDown(data)}
                defaultSelected={props.value}
                isMultiSelectPickList={false}
                onChange={(e: any) => props.handleChange({ name: props.items.name, value: e[0].value})}
                hasTooltip={props.hasTooltip}
                tooltipText={props.tooltipText}
            />
        </div>
    )
}
export default EngagmentSelectPicker;